import { PostCodeResult } from '@dto';

export class AreaReportVO {
  constructor(public readonly postCodeReport: PostCodeResult,
              public readonly nationalReport: PostCodeResult) {
  }
}

export const EMPTY_AREA_REPORT = new AreaReportVO(null,  null);
